import { FC } from 'react';
import { Button } from '@/common/components/ui/button';
import { ExternalLink } from 'lucide-react';

const Resume: FC = () => {
  return (
    <div className="space-y-12">
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Resume</h1>
        <p className="mt-3 text-lg text-gray-600">A summary of my professional experience and qualifications.</p>
        <div className="mt-6">
          <Button asChild>
            <a href="/assets/docs/resume.pdf" target="_blank" rel="noopener noreferrer">
              <ExternalLink className="mr-2 h-4 w-4" />
              Download PDF
            </a>
          </Button>
        </div>
      </div>

      {/* Education Section */}
      <section>
        <h2 className="text-2xl font-bold text-gray-800 border-b pb-3 mb-6">Education</h2>
        <div className="space-y-4">
          <div>
            <h3 className="text-xl font-semibold">Loyola University New Orleans College of Law</h3>
            <p className="text-gray-600">Juris Doctor (J.D.) Candidate | Top 33%</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold">Texas State University</h3>
            <p className="text-gray-600">Bachelor of Business Administration, Management</p>
          </div>
        </div>
      </section>

      {/* Professional Experience Section */}
      <section>
        <h2 className="text-2xl font-bold text-gray-800 border-b pb-3 mb-6">Professional Experience</h2>
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold">Director of Communications</h3>
            <p className="text-gray-600 font-medium italic">Galveston County</p>
            <ul className="list-disc list-inside mt-2 text-gray-700 space-y-1">
              <li>Managed all internal and external communications, serving as the primary media contact.</li>
              <li>Developed and executed strategic communication plans for county initiatives.</li>
              <li>Authored press releases, emergency guides, and social media content.</li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-semibold">Quality Assurance Manager</h3>
            <p className="text-gray-600 font-medium italic">Murphy Nasica & Associates</p>
            <ul className="list-disc list-inside mt-2 text-gray-700 space-y-1">
              <li>Oversaw quality control for a high volume of client-facing materials.</li>
              <li>Ensured brand consistency and accuracy across all communications.</li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-semibold">Strategic Policy Director</h3>
            <p className="text-gray-600 font-medium italic">Turning Point USA</p>
            <ul className="list-disc list-inside mt-2 text-gray-700 space-y-1">
              <li>Developed and advocated for key policy initiatives.</li>
              <li>Coordinated with stakeholders to advance organizational goals.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section>
        <h2 className="text-2xl font-bold text-gray-800 border-b pb-3 mb-6">Skills & Languages</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Skills</h3>
            <ul className="list-disc list-inside text-gray-700">
              <li>Strategic Communications</li>
              <li>Public & Media Relations</li>
              <li>Crisis Management</li>
              <li>Policy Analysis</li>
              <li>Legal Research & Writing</li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-2">Languages</h3>
            <ul className="list-disc list-inside text-gray-700">
              <li>English (Native)</li>
              <li>Spanish (Proficient)</li>
              <li>German (Intermediate)</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resume;
